module.exports = __webpack_public_path__ + "static/media/Cooperationbg3@2x.cf651b55.png";